import { apiSlice } from "./apiSlice";
import { setProfile } from "./authSlice";

export const userApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    register: builder.mutation({
      query: (userData) => ({
        url: "/users/register",
        method: "POST",
        body: userData,
      }),
      invalidatesTags: ["Auth"],
    }),

    login: builder.mutation({
      query: (userData) => ({
        url: "/users/login",
        method: "POST",
        body: userData,
      }),
      invalidatesTags: ["Auth"],
    }),

    loginWithCode: builder.mutation({
      query: ({ loginCode, email }) => ({
        url: `/users/loginWithCode/${email}`,
        method: "POST",
        body: loginCode,
      }),
      invalidatesTags: ["Auth"],
    }),

    sendLoginCode: builder.mutation({
      query: (email) => ({
        url: `/users/sendLoginCode/${email}`,
        method: "POST",
      }),
      invalidatesTags: ["Auth"],
    }),

    logout: builder.mutation({
      query: () => ({
        url: "/users/logout",
        method: "POST",
      }),
      invalidatesTags: ["Auth"],
    }),

    getUser: builder.query({
      query: () => ({
        url: "/users/getUser",
        method: "GET",
      }),
      providesTags: ["Auth"],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(setProfile(data.data));
        } catch (error) {
          console.error("Get user failed:", error);
        }
      },
    }),

    getUsers: builder.query({
      query: ({ page = 1, search } = {}) => {
        const params = new URLSearchParams();
        params.append("page", page);
        if (search) params.append("search", search);

        return {
          url: `/users/getUsers?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: ["Auth"],
    }),

    changePassword: builder.mutation({
      query: (userData) => ({
        url: "/users/changePassword",
        method: "PATCH",
        body: userData,
      }),
      invalidatesTags: ["Auth"],
    }),

    updateProfile: builder.mutation({
      query: (userData) => ({
        url: "/users/updateUser",
        method: "PATCH",
        body: userData,
      }),
      invalidatesTags: ["Auth"],
    }),

    forgotPassword: builder.mutation({
      query: (email) => ({
        url: "/users/forgotPassword",
        method: "POST",
        body: email,
      }),
      invalidatesTags: ["Auth"],
    }),

    resetPassword: builder.mutation({
      query: ({ password, resetToken }) => ({
        url: `/users/resetPassword/${resetToken}`,
        method: "PATCH",
        body: { password },
      }),
      invalidatesTags: ["Auth"],
    }),
    upgradeRole: builder.mutation({
      query: (userData) => ({
        url: "/users/upgradeRole",
        method: "PATCH",
        body: userData,
      }),
      invalidatesTags: ["Auth"],
    }),
    getUserById: builder.query({
      query: (id) => ({
        url: `/users/getUserById/${id}`,
        method: "GET",
      }),
    }),
    deleteUser: builder.mutation({
      query: (id) => ({
        url: `/users/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Auth"],
    }),
  }),
});

export const {
  useRegisterMutation,
  useLoginMutation,
  useLogoutMutation,
  useGetUserQuery,
  useGetUsersQuery,
  useChangePasswordMutation,
  useUpdateProfileMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation,
  useLoginWithCodeMutation,
  useSendLoginCodeMutation,
  useUpgradeRoleMutation,
  useGetUserByIdQuery,
  useDeleteUserMutation,
} = userApi;
